var map = {
	"./CombineProducts.png": 86475,
	"./Coupons.png": 81073,
	"./DailyTurnover.png": 97460,
	"./DuplicateProducts.png": 47075,
	"./InStore.png": 67744,
	"./Klarna.webp": 82905,
	"./LabelPrinter.png": 84260,
	"./LoyaltyPoints.png": 35999,
	"./Mailchimp.jpg": 16882,
	"./Mollie.png": 54532,
	"./MyParcel.png": 52119,
	"./NoBarcode.png": 46951,
	"./Picture_stylenumber.png": 82983,
	"./PostNL.png": 36806,
	"./Sale.png": 31699,
	"./SalesChannels.png": 66576,
	"./SendCloud.png": 10385,
	"./SeoDuplicates.png": 25017,
	"./Shipping.png": 20324,
	"./ShippingExport.png": 43362,
	"./SnelStart.png": 51320,
	"./TurnoverReports.png": 46088,
	"./UnifiedSMBPayments.png": 11311,
	"./VariabelProductNumber.png": 99780,
	"./VariableProductPrice.png": 24430,
	"./VariablePurchasePrice.png": 91228,
	"./WarehouseMutations.png": 80133,
	"./WebshopMails.png": 42360,
	"./WooCommerce.webp": 17980,
	"./seasons.png": 20398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27584;